import React from 'react';
import styled, { css, DefaultTheme } from 'styled-components';

const gridUnits =
  (u: number) =>
    ({ theme }: { theme: DefaultTheme }): string =>
      theme.grid.units(u);

const alertUiContainerTypes = {
  alertsBottom: css`
    z-index: 204;
    left: calc(50vw - ${gridUnits(10)});
    bottom: ${gridUnits(0.5)};
    width: ${gridUnits(20)};
  `,
  alertsMiddle: css`
    z-index: 203;
    left: calc(50vw - ${gridUnits(13)});
    bottom: calc(50vh - ${gridUnits(2)});
    width: ${gridUnits(26)};
  `,
  alertsRight: css`
    z-index: 204;
    right: ${gridUnits(0.5)};
    top: ${gridUnits(5)};
    width: ${gridUnits(14)};
  `,
  alertsTop: css`
    z-index: 202;
    top: ${gridUnits(0.5)};
    left: calc(50vw - ${gridUnits(14.5)});
    width: ${gridUnits(29)};
  `,
};

export const Container = styled.div`
  position: absolute;
  z-index: 200;
`;

interface AlertContainerProps {
  alertUiContainerType?: keyof typeof alertUiContainerTypes;
}

export const AlertContainer = styled.div<AlertContainerProps>`
  touch-action: none;
  border: 0.5px solid ${({ theme: { colors } }) => colors.alert};
  z-index: 200;
  position: fixed;
  width: ${gridUnits(20)};
  background-color: ${({ theme: { colors } }) => colors.white};
  padding: ${gridUnits(0.75)};
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.3);
  ${(props) =>
    alertUiContainerTypes[
      props.alertUiContainerType as keyof typeof alertUiContainerTypes
    ] || alertUiContainerTypes.alertsBottom};
`;

export const Header = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.h5};
  display: flex;
`;

export const HeaderContent = styled.div`
  cursor: move;
  flex: 1;
  margin-bottom: ${gridUnits(0.25)};
`;

export const AlertX = styled((props: React.ComponentPropsWithoutRef<'span'>) => (
  <span {...props}>X</span>
))`
  font-size: ${({ theme }) => theme.fontSizes.h5};
  margin-left: ${gridUnits(0.5)};
  color: ${({ theme: { colors } }) => colors.alert};
  cursor: pointer;
`;

export const ChildAlert = styled.div`
  margin-top: ${gridUnits(0.25)};
  display: flex;
  flex-direction: row;

  ${AlertX} {
    font-size: ${({ theme }) => theme.fontSizes.h6};
    color: ${({ theme: { colors } }) => colors.error};
    margin-right: ${gridUnits(1.5)};
  }
`;
